import { __assign, __rest } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import { Text } from '@marvelapp/ui';
function MessageBlock(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(Text, __assign({}, props), children);
}
MessageBlock.propTypes = {
    children: PropTypes.any,
};
MessageBlock.defaultProps = {
    bg: 'snowExtraDark',
    borderRadius: 1,
    color: 'slate',
    display: 'block',
    fontSize: 3,
    px: 4,
    py: 3,
};
export default MessageBlock;
